// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3PJPS","left":"InfoRow_left__1AB2Q"};